import { Country } from 'acscp/api/models/country';
import { StringValidationChecks, ValidationCheck } from 'acscp/components/common/helpers/validationChecks';
import { countryRequiresState } from 'acscp/components/common/helpers/countryHelper';

export class StateValidationChecks {
    static isStateSelectionValidForCountry = (getStateId: () => string, getCountry: () => Country | undefined): ValidationCheck => {
        return () => {
            const country = getCountry();
            const stateId = getStateId();

            if (country === undefined) {
                return stateId === '';
            }

            if (stateId === '') {
                return !countryRequiresState(country);
            }

            const validStateIds = country.states.map(s => s.id);
            return validStateIds.indexOf(getStateId()) > -1;
        };
    }
}
